import React from 'react';
import { useTranslation } from 'react-i18next';

import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { Body, Utility } from '@swyftx/aviary/atoms/Typography';
import { ReviewItem } from '@swyftx/aviary/molecules/ReviewItem/ReviewItem';
import { MarginInstrument } from '@swyftx/margin/build/types';
import { getInstrumentOpenTimes } from '@swyftx/margin/build/utils/instrumentTimes';

type Props = {
  market?: MarginInstrument;
};

const MarginInstrumentInformationTradingHours: React.FC<Props> = ({ market }) => {
  const { t } = useTranslation('margin');

  if (!market) return null;

  return (
    <FlexLayout direction='column' spacing={12}>
      <Utility variant='caption' color='primary' weight='bold'>
        {t('instruments.information.tradingHours.title')}
      </Utility>
      {getInstrumentOpenTimes(market.times).map((time) => (
        <FlexLayout direction='column' spacing={12} key={time.from}>
          <ReviewItem title={t('instruments.information.openHours.title')}>
            <FlexLayout direction='column' alignItems='end'>
              <Body weight='bold'>
                {t(`instruments.information.tradingHours.days.${time.from}` as any)}{' '}
                {t('instruments.information.tradingHours.to')}{' '}
                {t(`instruments.information.tradingHours.days.${time.to}` as any)}
              </Body>
              <Body size='xsmall' color='secondary'>
                {t('instruments.information.tradingHours.tradingHours', {
                  from: time.open.toFormat('h:mm a'),
                  to: time.close.toFormat('h:mm a'),
                })}
              </Body>
            </FlexLayout>
          </ReviewItem>
        </FlexLayout>
      ))}
    </FlexLayout>
  );
};

export { MarginInstrumentInformationTradingHours };
